import { LazyLoad } from '@petconsole/pure-fe-mui';

const PlaceAdmin = LazyLoad(() => import('./PlaceAdmin'));

export { PlaceAdmin };
